import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { $Locale } from '@hubio/hubio-common-components';

@Component({
  selector: 'app-file-drop-modal',
  templateUrl: './file-drop-modal.component.html',
  styleUrls: ['./file-drop-modal.component.scss']
})
export class FileDropModalComponent {

  public data: string;
  public fileName: string;

  constructor(
    private dialogRef: MatDialogRef<FileDropModalComponent>,
    public $Locale: $Locale
  ) { }

  public close() {
    this.dialogRef.close();
  }

  public upload() {
    this.dialogRef.close({data: this.data});
  }

  public dropHandler(ev) {
    ev.preventDefault();
    
    if (ev.dataTransfer.files) {
      const reader = new FileReader();
      [...ev.dataTransfer.files].forEach((file, i) => {
        this.fileName = file.name;
        reader.readAsText(file);
        reader.addEventListener('load', () => {
            const content = reader.result.toString();
            this.data = content;
        });

      });
    }
  }

  public dragOverHandler(ev) {
    ev.preventDefault();
  }

}
